module.exports = __webpack_public_path__ + "gr.svg?1eee8319085a21e25a3a8a0f82b087cc";